__turbopack_context__.v({
  "buttons": "recommended-products-module-scss-module__OoL98a__buttons",
  "buttons__nextButton": "recommended-products-module-scss-module__OoL98a__buttons__nextButton",
  "buttons__prevButton": "recommended-products-module-scss-module__OoL98a__buttons__prevButton",
  "skeletons": "recommended-products-module-scss-module__OoL98a__skeletons",
  "slide": "recommended-products-module-scss-module__OoL98a__slide",
  "slider": "recommended-products-module-scss-module__OoL98a__slider",
  "swiper": "recommended-products-module-scss-module__OoL98a__swiper",
});
